// extracted by mini-css-extract-plugin
export default {"mobStickyFooter":"StickyFooter_mobStickyFooter__88US1","footerDivider":"StickyFooter_footerDivider__AwR4I","menuContainer":"StickyFooter_menuContainer__yck5j"};